const BROADBAND_OFFERS = [
  { offerNbr: "WAPTT/20", offerName: "天天宽带20M-全能办专用", speed: "20M", period: "全能办" },
  { offerNbr: "7710135000101099", offerName: "300M_300元/6个月-全能办专用", speed: "300M", period: "6个月", price: "300" },
  { offerNbr: "7710135000101100", offerName: "300M_480元/12个月-全能办专用", speed: "300M", period: "12个月", price: "480" },
  { offerNbr: "7710135000101101", offerName: "300M_840元/24个月-全能办专用", speed: "300M", period: "24个月", price: "840" },
  { offerNbr: "7710135000101102", offerName: "300M_1080元/36个月-全能办专用", speed: "300M", period: "36个月", price: "1080" },
  { offerNbr: "7710135000101103", offerName: "500M_360元/6个月-全能办专用", speed: "500M", period: "6个月", price: "360" },
  { offerNbr: "7710135000101104", offerName: "500M_600元/12个月-全能办专用", speed: "500M", period: "12个月", price: "600" },
  { offerNbr: "7710135000101105", offerName: "500M_1080元/24个月-全能办专用", speed: "500M", period: "24个月", price: "1080" },
  { offerNbr: "7710135000101106", offerName: "500M_1440元/36个月-全能办专用", speed: "500M", period: "36个月", price: "1440" },
  { offerNbr: "7710135000101107", offerName: "1000M_480元/6个月-全能办专用", speed: "1000M", period: "6个月", price: "480" },
  { offerNbr: "7710135000101108", offerName: "1000M_840元/12个月-全能办专用", speed: "1000M", period: "12个月", price: "840" },
  { offerNbr: "7710135000101109", offerName: "1000M_1560元/24个月-全能办专用", speed: "1000M", period: "24个月", price: "1560" },
  { offerNbr: "7710135000101110", offerName: "1000M_2160元/36个月-全能办专用", speed: "1000M", period: "36个月", price: "2160" },
];

function pad(value) {
  return String(value).padStart(2, "0");
}

function createBroadbandOrderNo(date = new Date()) {
  const timestamp = [
    date.getFullYear(),
    pad(date.getMonth() + 1),
    pad(date.getDate()),
    pad(date.getHours()),
    pad(date.getMinutes()),
    pad(date.getSeconds()),
  ].join("");
  const random = String(Math.floor(Math.random() * 1000)).padStart(3, "0");
  return `B${timestamp}${random}`;
}

function validateBroadbandOrderForm(form) {
  const requiredRules = [
    ["customerName", "请输入客户姓名"],
    ["linkPhone", "请输入联系电话"],
    ["certNum", "请输入身份证号"],
    ["city", "请输入地市"],
    ["county", "请输入区县"],
    ["receiverAddr", "请输入装机详细地址"],
    ["offerNbr", "请选择宽带套餐"],
  ];

  for (const [key, message] of requiredRules) {
    if (!String(form[key] || "").trim()) {
      return { valid: false, message };
    }
  }

  if (!/^1[3-9]\d{9}$/.test(form.linkPhone)) {
    return { valid: false, message: "请输入正确的联系电话" };
  }

  if (!/^\d{17}[\dXx]$/.test(form.certNum)) {
    return { valid: false, message: "请输入正确的身份证号" };
  }

  return { valid: true, message: "" };
}

function getOffer(offerNbr) {
  return BROADBAND_OFFERS.find((item) => item.offerNbr === offerNbr) || BROADBAND_OFFERS[0];
}

function clonePlainObject(value) {
  return JSON.parse(JSON.stringify(value || {}));
}

function normalizeAreaList(source) {
  const province_list = clonePlainObject(source.province_list);
  const city_list = clonePlainObject(source.city_list);
  const county_list = clonePlainObject(source.county_list);

  Object.keys(province_list).forEach((code) => {
    const provincePrefix = code.slice(0, 2);
    const hasCity = Object.keys(city_list).some((cityCode) => cityCode.slice(0, 2) === provincePrefix);
    if (!hasCity) {
      delete province_list[code];
    }
  });

  Object.keys(city_list).forEach((code) => {
    if (!province_list[`${code.slice(0, 2)}0000`]) {
      delete city_list[code];
    }
  });

  Object.keys(county_list).forEach((code) => {
    if (!city_list[`${code.slice(0, 4)}00`]) {
      delete county_list[code];
    }
  });

  return { province_list, city_list, county_list };
}

function buildBroadbandSubmitPayload(form, partnerOrderNo = createBroadbandOrderNo()) {
  const offer = getOffer(form.offerNbr);
  const payload = {
    partnerOrderNo,
    linkPhone: form.linkPhone.trim(),
    customerName: form.customerName.trim(),
    certNum: form.certNum.trim(),
    city: form.city.trim(),
    county: form.county.trim(),
    receiverAddr: form.receiverAddr.trim(),
    offerNbr: offer.offerNbr,
    offerName: offer.offerName,
    orderType: "2",
    amount: "0",
    certType: "1",
    linkman: form.customerName.trim(),
    provinces: String(form.provinces || "山东省").trim(),
    expenseExplain: offer.offerName,
    busiSource: "38",
    busiSecene: "2",
  };

  ["distributionChannel", "orderSource", "remark", "depositNbr"].forEach((key) => {
    const value = String(form[key] || "").trim();
    if (value) {
      payload[key] = value;
    }
  });

  return payload;
}

module.exports = {
  BROADBAND_OFFERS,
  createBroadbandOrderNo,
  validateBroadbandOrderForm,
  normalizeAreaList,
  buildBroadbandSubmitPayload,
};
